module.exports = __webpack_public_path__ + "static/media/copy.8768450d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy.svg
// module id = 856
// module chunks = 0